<div class="animated fadeIn backend">
  <div class="row">
    <div class="col-12">
      <div class="top-header-area">
        <div class="header-area">
          <h3>Tree Species</h3>
        </div>
        <form class="button-area" (ngSubmit)="filterUpdated()">
          <div class="input-group search">
              <input type="text"
                      name="search"
                      class="form-control"
                      placeholder="Search by species"
                      aria-label="Search..."
                      [(ngModel)]="searchText"
                      aria-describedby="basic-addon2">
              <div class="input-group-append">
                  <button class="btn" type="submit"><i class="icon-magnifier"></i></button>
              </div>
          </div>
          <div class="form-inline">
              <label for="name">Items per page</label>
              <select class="form-control custom-select" 
                  name="customerType" [(ngModel)]="pageSize" (ngModelChange)="updatePageSize()">
                  <option value="10">10</option>
                  <option value="25">25</option>
                  <option value="50">50</option>
                  <option value="100">100</option>
              </select>
          </div>
          <button type="button" class="btn btn-primary" (click)="openEditModal(ModalType.add)"><i class="icon-plus icons"></i> Add</button>
        </form>
      </div>
    </div>
    <div class="col-12">
      <perfect-scrollbar class="table-area" [config]="config">
        <table class="table table-hover customer">
          <thead class="thead-light">
            <tr>
              <th *ngFor="let col of columns" [class.sorting]="col.canSort"
                  [class.acs]="sortColumn === col && sortAsc"
                  [class.dcs]="sortColumn === col && !sortAsc"
                  [class.text-right]="col.textRight" (click)="sort(col)">{{col.title}}
              </th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let specie of pageSpecies">
              <td><a href="javascript:void(0)" (click)="openEditModal(ModalType.edit, specie)">{{specie.species}}</a></td>
              <td>{{specie.description}}</td>
              <td *ngIf="specie.photoUrl">Yes</td>
              <td *ngIf="!specie.photoUrl">No</td>
              <td class="table-button">
                <a class="edit" (click)="openEditModal(ModalType.edit, specie)"><i class="icon-note"></i></a>
                <a class="delete" (click)="openDeleteModal(specie.id)" title="Delete"><i class="icon-trash"></i></a>
              </td>
            </tr>
          </tbody>
        </table>
      </perfect-scrollbar>
      <div class="no-data" *ngIf="filteredSpecies.length == 0">
          <h2><i class="icon-layers"></i></h2>
          <h3>The list is empty.</h3>
      </div>
      
      <pagination [itemsPerPage]="pageSize" [style.display]="filteredSpecies.length > 0 ? 'block' : 'none'"
                  [totalItems]="filteredSpecies.length"
                  [(ngModel)]="page"
                  (pageChanged)="pageChange($event.page)"></pagination>
    </div>
  </div>
</div>

<!-- Modal delete -->
<div bsModal #deleteModal="bs-modal" class="modal fade" tabindex="-1" role="dialog" aria-labelledby="dialog-sizes-name1" [config]="{backdrop: 'static',  keyboard: false}">
  <div class="modal-dialog modal-form modal-confirm modal-md modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-body">
        <h4>Are you sure?</h4>
        <p>You won't be able to revert this!</p>
        <p>This species is assigned to below planting site(s).</p>
        <div class="copy-to-clipboard">
          <div class="form-group">
            <textarea class="form-control" #userinput>{{plantingSiteList}}</textarea>
          </div>
          <div class="button-copy-wrapper">
            <button type="button" class="btn btn-outline-dark btn-icon" (click)="copyInputMessage(userinput)"><i class="icon-docs"></i>Copy</button>
            <p *ngIf="copied" class="small text-success mt-2">Copied</p>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-danger" (click)="confirmDelete()">Yes, delete it</button>
        <button type="button" class="btn btn-outline-dark" data-dismiss="modal" (click)="deleteModal.hide()">Cancel</button>
      </div>
    </div>
  </div>
</div>
